/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@chakra-ui/button";
import { useClipboard } from "@chakra-ui/hooks";
import { CopyIcon } from "@chakra-ui/icons";
import { Badge, Box, Flex, Heading } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import { Tooltip } from "@chakra-ui/tooltip";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";
import firebase from "../../firebase";
import { userObjectConstructor } from "../../helpers/objects";
import theme from "../../helpers/theme";
import { ApplicationView } from "../ApplicationView";
import { Layout } from "../Layout";
import { MemberView } from "../MemberView";
import { PostList } from "../PostList";
import { SidebarView } from "../SidebarView";

export const ClubView = props => {
	const [club, setClub] = useState();
	const { onCopy } = useClipboard(
		club && club !== undefined && club.data.title
	);
	const [myClubs, setMyClubs] = useState();
	const [present, setPresent] = useState();
	const history = useHistory();

	const { currentUser } = useAuth();
	const [user, setUser] = useState({
		id: currentUser.uid,
		role: "student",
		settings: { notifs: "all" },
	});

	const fetchMyClubs = uid => {
		const unsubscribe = firebase
			.firestore()
			.collectionGroup("clubs")
			.where("members", "array-contains", uid)
			.onSnapshot(raw => {
				if (raw.docs.length <= 0) {
					return;
				}

				const data = raw.docs.map(doc => ({
					data: doc.data(),
					id: doc.id,
					ref: doc.ref,
				}));
				setMyClubs(data);
			});

		return unsubscribe;
	};

	const fetchMe = () => {
		const userRef = firebase
			.firestore()
			.collection("users")
			.doc(currentUser.uid);
		const unsubscribe = userRef.onSnapshot(dbuser => {
			if (!dbuser.data() || !dbuser.data().id) {
				userRef.set(
					userObjectConstructor({
						id: currentUser.uid,
						role: "student",
						settings: { notifs: "all" },
					})
				);
			} else setUser(dbuser.data());
		});
		return unsubscribe;
	};

	const applyToClub = async () => {
		const appRef = club.ref;
		const data = await appRef.get();
		const apps = data.data().applications;

		if (apps.find(uid => uid === currentUser.uid) !== undefined) return;

		appRef.update({ applications: [...apps, currentUser.uid] });
	};

	useEffect(() => {
		const unsub = fetchMyClubs(currentUser.uid);
		const unsub2 = fetchMe(currentUser.uid);
		return () => {
			const promises = [unsub, unsub2];
			Promise.all(promises).then(() => console.log("cleared"));
		};
	}, [currentUser.uid]);

	useEffect(() => {
		const clubid = props.match.params.clubid;

		let clubf;

		if (myClubs) clubf = myClubs.find(club => club.id === clubid);

		if (!clubf) {
			if (user.role !== "admin") setPresent(false);
			else setPresent(true);
			const unsubscribe = firebase
				.firestore()
				.collectionGroup("clubs")
				.where("id", "==", clubid)
				.onSnapshot((club, err) => {
					const clubbo = club.docs[0];

					if (!clubbo || clubbo.length === 0) {
						history.push("/main");
						return;
					}

					setClub({
						data: clubbo.data(),
						id: clubbo.id,
						ref: clubbo.ref,
					});
				});
			return unsubscribe;
		}

		setPresent(true);
		setClub(clubf);
	}, [props, currentUser.uid, myClubs, club]);

	const deleteClub = () => {
		const ref = club.ref;

		ref.delete();
		history.push("/login");
	};

	return (
		<Skeleton isLoaded={club}>
			<Layout wide>
				<Box
					rounded="lg"
					bg="gray.100"
					w="100%"
					userSelect="none"
					// boxShadow="0 2px 5px -2px gray"
				>
					{club && user && (
						<>
							<Box
								roundedTop="lg"
								w="100%"
								h={{ base: "13rem", md: "23rem" }}
								bgImage={`url(${club.data.imageUrl})`}
							/>
							<Box margin="5" mt={0} mb="9">
								<Flex
									justifyContent="space-between"
									alignItems="flex-end"
								>
									<Heading size="lg" mt="9" mb="3">
										{club.data.title}
										<Tooltip
											label="Copy Text"
											fontSize="xs"
										>
											<CopyIcon
												onClick={onCopy}
												ml="3"
												fontSize="md"
												color="gray.500"
												cursor="pointer"
												_hover={{ color: "black" }}
											/>
										</Tooltip>
									</Heading>
									<Button
										mb={2}
										variant="ghost"
										colorScheme="red"
										onClick={deleteClub}
									>
										Delete Club
									</Button>
								</Flex>
								<Flex>
									{club.data.badges &&
									club.data.badges.length === 1 ? (
										<Badge
											borderRadius="full"
											px="2"
											mr="2"
											colorScheme="teal"
										>
											{club.data.badges[0]}
										</Badge>
									) : club.data.badges &&
									  club.data.badges.length > 1 ? (
										<>
											<Badge
												borderRadius="full"
												px="2"
												mr="2"
												colorScheme="teal"
											>
												{club.data.badges[0]}
											</Badge>
											<Badge
												borderRadius="full"
												px="2"
												mr="2"
												colorScheme="pink"
											>
												{club.data.badges[1]}
											</Badge>
										</>
									) : (
										<Badge
											borderRadius="full"
											px="2"
											mr="2"
											colorScheme="blue"
										>
											New
										</Badge>
									)}
									<Box
										color="gray.500"
										fontWeight="semibold"
										letterSpacing="wide"
										fontSize="xs"
										textTransform="uppercase"
										ml="2"
									>
										{club.data.members.length} Members
									</Box>
								</Flex>
							</Box>
						</>
					)}
				</Box>
				{present ? (
					<Flex
						justifyContent="space-between"
						width="100%"
						flexDir={{ base: "column-reverse", lg: "row" }}
					>
						<Box mt="12" w={{ base: "100%", lg: "60%" }} pt="10">
							<Tabs
								variant="soft-rounded"
								colorScheme={theme.colours.accent}
								w="100%"
								d="flex"
								justifyContent="center"
								alignItems="center"
								flexDir="column"
							>
								<TabList
									userSelect="none"
									d="flex"
									flexDir={{ base: "column", md: "row" }}
									w={{ base: "100%", md: "auto" }}
									mb={8}
								>
									<Tab
										w={{ base: "100%", md: "auto" }}
										mr={{ base: "0", md: "1rem" }}
										mb={{ base: "1rem", md: "0" }}
									>
										Posts
									</Tab>
									<Tab
										w={{ base: "100%", md: "auto" }}
										mr={{ base: "0", md: "1rem" }}
										mb={{ base: "1rem", md: "0" }}
									>
										Members
									</Tab>
									{(user.role === "admin" ||
										user.role === "moderator") && (
										<Tab
											color="teal.400"
											w={{ base: "100%", md: "auto" }}
											mr={{ base: "0", md: "1rem" }}
											mb={{ base: "1rem", md: "0" }}
										>
											Applications
										</Tab>
									)}
									{/* {(user.role === "admin" ||
										user.role === "moderator") && (
										<Tab
											color="teal.400"
											w={{ base: "100%", md: "auto" }}
											mr={{ base: "0", md: "1rem" }}
											mb={{ base: "1rem", md: "0" }}
										>
											Settings
										</Tab>
									)} */}
								</TabList>
								<TabPanels>
									<TabPanel>
										<PostList
											isAdmin={
												user.role === "admin" ||
												user.role === "moderator"
											}
											clubRef={club.ref}
										/>
									</TabPanel>
									<TabPanel>
										<MemberView
											isAdmin={
												user.role === "admin" ||
												user.role === "moderator"
											}
											clubRef={club.ref}
										/>
									</TabPanel>
									{(user.role === "admin" ||
										user.role === "moderator") && (
										<TabPanel>
											<ApplicationView
												isAdmin={
													user.role === "admin" ||
													user.role === "moderator"
												}
												clubRef={club.ref}
											/>
										</TabPanel>
									)}
									{/* {(user.role === "admin" ||
										user.role === "moderator") && (
										<TabPanel>
											<ClubList clubs="mine" />
										</TabPanel>
									)} */}
								</TabPanels>
							</Tabs>
						</Box>

						<Box
							mt="12"
							w={{ base: "100%", lg: "40%" }}
							pt="10"
							id="events"
						>
							<SidebarView
								isAdmin={
									user.role === "admin" ||
									user.role === "moderator"
								}
								clubRef={club.ref}
							/>
						</Box>
					</Flex>
				) : (
					<Box
						rounded="lg"
						bg="gray.100"
						w={{ base: "100%", md: "40%" }}
						userSelect="none"
						mt={5}
						d="flex"
						p={10}
						flexDir="column"
						justifyContent="center"
						alignItems="center"
						textAlign="center"
					>
						<Heading size="md" mb="7">
							You are not in this club, apply to join!
						</Heading>
						<Button
							colorScheme="green"
							bgColor="green.300"
							color="gray.600"
							px="5"
							py="6"
							onClick={applyToClub}
							_hover={{
								color: "white",
							}}
						>
							Apply to club!
						</Button>
					</Box>
				)}
			</Layout>
		</Skeleton>
	);
};
